/**
 * @file audio-track-button.js
 */
'use strict';

exports.__esModule = true;

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _trackButtonJs = require('../track-button.js');

var _trackButtonJs2 = _interopRequireDefault(_trackButtonJs);

var _componentJs = require('../../component.js');

var _componentJs2 = _interopRequireDefault(_componentJs);

var _utilsFnJs = require('../../utils/fn.js');

var Fn = _interopRequireWildcard(_utilsFnJs);

var _audioTrackMenuItemJs = require('./audio-track-menu-item.js');

var _audioTrackMenuItemJs2 = _interopRequireDefault(_audioTrackMenuItemJs);

/**
 * The base class for buttons that toggle specific text track types (e.g. subtitles)
 *
 * @param {Player|Object} player
 * @param {Object=} options
 * @extends TrackButton
 * @class AudioTrackButton
 */

var AudioTrackButton = (function (_TrackButton) {
  _inherits(AudioTrackButton, _TrackButton);

  function AudioTrackButton(player) {
    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

    _classCallCheck(this, AudioTrackButton);

    options.tracks = player.audioTracks && player.audioTracks();

    _TrackButton.call(this, player, options);

    this.el_.setAttribute('aria-label', 'Audio Menu');
  }

  /**
   * Allow sub components to stack CSS class names
   *
   * @return {String} The constructed class name
   * @method buildCSSClass
   */

  AudioTrackButton.prototype.buildCSSClass = function buildCSSClass() {
    return 'vjs-audio-button ' + _TrackButton.prototype.buildCSSClass.call(this);
  };

  /**
   * Create a menu item for each audio track
   *
   * @return {Array} Array of menu items
   * @method createItems
   */

  AudioTrackButton.prototype.createItems = function createItems() {
    var items = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];

    var tracks = this.player_.audioTracks && this.player_.audioTracks();

    if (!tracks) {
      return items;
    }

    for (var i = 0; i < tracks.length; i++) {
      var track = tracks[i];

      items.push(new _audioTrackMenuItemJs2['default'](this.player_, {
        // MenuItem is selectable
        'selectable': true,
        'track': track
      }));
    }

    return items;
  };

  return AudioTrackButton;
})(_trackButtonJs2['default']);

_componentJs2['default'].registerComponent('AudioTrackButton', AudioTrackButton);
exports['default'] = AudioTrackButton;
module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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